<template>
  <div class="container">
    <el-row>
      <el-col :span="12">
        <ProductImageViewer :images="productImages" />
      </el-col>
      <el-col :span="12">
        <div class="col-right">

        </div>
      </el-col>
    </el-row>

  </div>

</template>



<script>
import ProductImageViewer from '@/components/swiper-goods/ProductCarouselPC.vue'

export default {
  name: 'App',
  components: {
    ProductImageViewer
  },
  data() {
    return {
      productImages: [
        ' https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=720&h=720&fit=crop',
        ' https://images.unsplash.com/photo-1526170375885-4d8ecf77b99f?w=720&h=720&fit=crop',
        ' https://images.unsplash.com/photo-1546868871-7041f2a55e12?w=720&h=720&fit=crop',
        ' https://images.unsplash.com/photo-1560769629-975ec94e6a86?w=720&h=720&fit=crop',
        ' https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=720&h=720&fit=crop',
        ' https://images.unsplash.com/photo-1559056199-641a0ac8b55e?w=720&h=720&fit=crop',
        ' https://images.unsplash.com/photo-1485955900006-10f4d324d411?w=720&h=720&fit=crop'
      ]
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;
  background: #f5f5f5;
  padding: 20px;
}

.container {
  max-width: 1440px;
  margin: 0 auto;
  padding: 40px;
  background: white;
}

h1 {
  text-align: center;
  margin-bottom: 40px;
  color: #333;
  font-weight: 600;
  font-size: 28px;
}
</style>